import { EDGAR } from './documents';

const USER_DEFINABLE = [
  'Uploaded Earnings Call Transcript',
  'Uploaded Conference Transcript',
  'Loan Agreement',
  'Lender Call',
  'Prospectus',
  'Indenture',
  'Disclosure Statement',
  'Plan of Reorg',
  'Research',
  'Expert Network Call',
  'PPM',
  'CIM',
  'News Article',
  'Court Case Filing',
  'Contract',
  'Commentary',
  'Annual Report',
  'Financial Statements',
  'Financial Model',
  'Investor Letter',
  'Investment Memo',
  'Side Letter',

  'Unaudited Statements/Transparency',
  'Agreements',
  'Audited Financial Statements',
  'Fund Services: Cash Flows/ Invoices/ Other Transactions',
  'Manager Periodic Investor Letter Update',
  'Presentation/Marketing Material/Other Communications',
  'Other Monitoring Documents',
  'Tax',
  'Other',
];

export let UPLOAD_DOC_TYPE_OPTIONS = [...EDGAR.sort(), ...USER_DEFINABLE.sort()];

export const setUploadDocTypeOptions = (options) => {
  UPLOAD_DOC_TYPE_OPTIONS = options;
};

export const UPLOADED_DOC_TYPES = [
  '10-K',
  '10-Q',
  '8-K',
  '20-F',
  '40-F',
  '6-K',
  'S-1',
  'Earnings Call Transcript',
  'Conference Transcript',
];
